import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { errorToast, successToast } from "../../../../utils/toasts";
import { type OrgPropertyUpdateSchema } from "../../../../zodios/apiDefinitions/api/orgs";
import { apiClient } from "../../../../zodios/client";
import { invalidateOrgQueries } from "./invalidateOrgQueries";

export function useBulkUpdateOrgProperties() {
  const queryClient = useQueryClient();
  const { t } = useTranslation(["perf_reports"]);
  return useMutation({
    mutationFn: async (vars: OrgPropertyUpdateSchema) => {
      await apiClient.bulkUpdateOrgProperties(vars);
    },
    onSuccess: () => {
      successToast({ message: t(($) => $.perf_reports["Organizations Successfully Updated"]) });
      invalidateOrgQueries(queryClient);
    },
    onError: (error) => {
      errorToast({ message: t(($) => $.perf_reports["Failed to Update Organizations"]), error });
    },
  });
}
